<template>
  <div class="application">
    <div class="application-task">
      <div v-for="(item,index) in list" :key="index" class="task-one" :class="item.process? 'finished': index === 3?'ing':''">
         {{index+1}}.{{item.nameEn}}
        <div class="box">
          <div v-if="!item.process"></div>
          <i v-else class="icon iconfont icon-duigou" style="color:#fff;"></i>
        </div>
      </div>
      <!-- <div class="task-one">
        完成
        <div class="box"><div></div></div>
      </div> -->
      <div class="line"></div>
    </div>
    <div class="application-header">
      <p>Exhibition Application/参展申请</p>
      <span></span>
      <p>Preview/预览</p>
    </div>

    <div class="application-content">
      <div class="content-title">
        <span class="l">Company Information/基本信息</span>
        <span class="r s-red-color" @click="editBasic">Modificated/修改</span>
      </div>

      <div class="content-com" v-if="basicInfo">
        <span>Company Name/公司名称：</span>
        <p>{{basicInfo.companyName}}</p>
        <!-- <span>英文名称：</span>
        <p>{{basicInfo.companyNameEn}}</p>
        <span>公司简称：</span>
        <p>{{basicInfo.companyNameShort}}</p> -->
        <span>Company Address/公司地址：</span>
        <p>{{basicInfo.country}} {{basicInfo.province}} {{basicInfo.city}} {{basicInfo.county}} {{basicInfo.address}} {{basicInfo.postcode}}</p>
        <span>Website/公司官网：</span>
        <p>{{basicInfo.website}}</p>
      </div>

      <div class="content-title2">
        <div>
          <span class="l">Contact Person/展会联系人</span>
          <span class="r s-red-color" @click="editBasic">Modificated/修改</span>
        </div>
        <div>
          <span class="l">Marketing Personnel/市场部负责人</span>
          <span class="r s-red-color" @click="editBasic">Modificated/修改</span>
        </div>
      </div>

      <div class="content-link" v-if="basicInfo">
        <div>
          <span>Name/姓名：</span>
          <p>{{basicInfo.linkMan}}</p>
          <span>Position/职务：</span>
          <p>{{basicInfo.linkTitle}}</p>
          <span>Mobile number/手机：</span>
          <p>{{basicInfo.linkMob}}</p>
          <span>E-mail/邮箱：</span>
          <p>{{basicInfo.linkEmail}}</p>
          <!-- <span>电话：</span>
          <p>{{basicInfo.linkTelephone}}</p>
          <span>传真：</span>
          <p>{{basicInfo.linkFax}}</p> -->
        </div>
        <div>
          <span>Name/姓名：</span>
          <p>{{basicInfo.leader}}</p>
          <span>Position/职务：</span>
          <p>{{basicInfo.leaderTitle}}</p>
          <span>Mobile number/手机：</span>
          <p>{{basicInfo.leaderMob}}</p>
          <span>E-mail/邮箱：</span>
          <p>{{basicInfo.leaderEmail}}</p>
          <!-- <span>电话：</span>
          <p>{{basicInfo.leaderTelephone}}</p>
          <span>传真：</span>
          <p>{{basicInfo.leaderFax}}</p> -->
        </div>
      </div>

      <div class="content-title">
        <span class="l">VAT Invoice(中国增值税发票)</span>
        <span class="r s-red-color" @click="editBasic">Modificated/修改</span>
      </div>

      <div class="content-com" v-if="basicInfo">
        <template v-if="basicInfo.isInvoice === 'False'||basicInfo.isInvoice === 'false'">
          <span>发票抬头：</span>
          <p>{{basicInfo.invoiceTitle}}</p>
          <span>税号：</span>
          <p>{{basicInfo.invoiceCode}}</p>
          <span>单位地址：</span>
          <p>{{basicInfo.invoiceAddress}}</p>
          <span>电话号码：</span>
          <p>{{basicInfo.invoiceTelephone}}</p>
          <span>开户银行：</span>
          <p>{{basicInfo.invoiceBank}}</p>
          <span>银行账户：</span>
          <p>{{basicInfo.invoiceBankAccount}}</p>
          <span>开票类型:</span>
          <p>{{basicInfo.invoiceType}}</p>
          <span v-if="basicInfo.postAddr">邮寄地址：</span>
          <p>{{basicInfo.postAddr}}</p>
          <span>联系人：</span>
          <p>{{ basicInfo.postMan }}</p>
          <span>联系电话：</span>
          <p>{{ basicInfo.postTel }}</p>
        </template>
        <div v-else style="text-align: center;width: 100%;line-height: 116px;">No data!</div>
      </div>

      <div class="content-title">
        <div>
          <span class="l" style="margin-right:60px;">Booth Information/订单信息</span>
          <!-- <span class="l" v-if="orderInfo && orderInfo.applyBoothOrderList.length > 0 && orderInfo.isAgent === '否'">展区：{{orderInfo.applyBoothOrderList[0].dePjNameGroupName}}</span>
          <span class="l" v-if="orderInfo && orderInfo.applyBoothOrderList.length > 0 && orderInfo.isAgent === '是'">申请展团：{{orderInfo.applyBoothOrderList[0].dePjNameGroupName}}</span> -->
        </div>
        <span class="r s-red-color" @click="editBooth">Modificated/修改</span>
      </div>

      <div class="content-exHall">
        <div class="exHall" v-if="orderInfo && orderInfo.isAgent === '否'">
          <div class="exHall-one" v-for="(item,index) in orderList" :key="index" >
            <div class="top">
              <p>{{item.name}}</p>
              <!-- <p>单价：{{item.unitPrice}}{{item.monetaryUnit}}/{{item.unit}}</p> -->
              
              <p v-if="item.orderType === 'booth'">Specifications/规格：{{item.width}}×{{item.height}}={{item.area}}㎡</p>
              <template v-if="item.orderType === 'other'">
                <p v-if="item.durationType === '时间段'"> Date/时段：{{item.durationBegin | moment("YYYY/MM/DD")}}-{{item.durationEnd | moment("YYYY/MM/DD")}}</p>
                <p v-if="item.durationType === '时长'">Hours/时长：{{item.duration}}{{item.durationUnit}}</p>
                <p>Number/数量：{{item.quantity}}{{item.unit}}</p>
              </template>
              <!-- <p v-if="item.orderType === 'other'">规格：{{item.width}}×{{item.height}}={{item.area}}㎡</p> -->
              <!-- <p class="remark">{{item.remark}}1</p>
              <p>媒体推广费 RMB 3400.00</p> -->
            </div>
            <!-- <p class="subtotal">小计： {{item.monetaryUnit}} {{item.totalPrice}}</p> -->
          </div>
          <span class="line"></span>
          <!-- <p class="totalPrice" style="text-align:right;" v-if="orderInfo.applyBoothOrderList.length > 0">展位订单费用合计：{{orderUnint}} {{orderInfo.applyBoothOrderList[0].totalPrice}}</p>
          <p class="totalPrice" style="text-align:right;">CMO订单费用合计：{{orderUnint}} {{CMOprice}}</p>
          <p class="totalPrice" style="text-align:right;">增值服务合计：{{orderUnint}} {{Obligatory}}</p>
          <p class="totalPrice">费用总合计：{{orderUnint}} {{orderPrice}}</p> -->
        </div>
        <div class="exHall" v-if="orderInfo && orderInfo.isAgent === '是'">
          <div class="exHall-one" v-for="(item,index) in orderList" :key="index" style="height:auto;">
            <div class="top" style="border-bottom:0;height:auto;">
              <p>{{item.name}}</p>
               <p v-if="item.quantity">Number/数量：{{item.quantity}}{{item.unit}}</p>
              <p v-if="item.orderType === 'booth'">Specifications/规格：{{item.width}}×{{item.height}}={{item.area}}㎡</p>
              <template v-if="item.orderType === 'other'">
                <p v-if="item.durationType === '时间段'">Date/时段：{{item.durationBegin | moment("YYYY/MM/DD")}}-{{item.durationEnd | moment("YYYY/MM/DD")}}</p>
                <p v-if="item.durationType === '时长'">Hours/时长：{{item.duration}}{{item.durationUnit}}</p>
                <!-- <p>数量：{{item.quantity}}{{item.unit}}</p> -->
              </template>
              <!-- <p v-if="item.orderType === 'other'">规格：{{item.width}}×{{item.height}}={{item.area}}㎡</p> -->
              <!-- <p class="remark">{{item.remark}}1</p>
              <p>媒体推广费 RMB 3400.00</p> -->
            </div>
          </div>
        </div>
      </div>

      <div class="content-title">
        <span class="l">Company Profile/公司简介</span>
        <span class="r s-red-color" @click="editIntroduction">Modificated/修改</span>
      </div>

      <div class="content-introduction">
        <p style="margin-bottom:10px;">Company Profile in Chinese/公司中文介绍：</p>
        <p style="margin-bottom:30px;padding-left:30px;" v-if="introduction" v-html="introduction"></p>
        <p style="margin-bottom:10px;">Company Profile in English/公司英文介绍：</p>
        <p style="margin-bottom:30px;padding-left:30px;" v-if="introductionEn" v-html="introductionEn"></p>
      </div>

      <!-- <div class="content-title">
        <span class="l">报名表</span>
      </div> -->

      <!-- <div class="content-table"> -->
        <!-- <div class="f" @click="downloadPdf" >生成并下载展位确认函</div> -->
        <!-- <div style="display:flex;position:relative;flex:1;height:100px;justify-content:center;flex-wrap:wrap;padding-bottom:30px;">
          <Upload
            ref="upload"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :on-success="handleSuccess"
            :format="['jpg','png']"
            :max-size="51200"
            :headers="formHeaders"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            :action="uploadUrl"
            style="margin-bottom:15px;"
          >
            <div class="upload-btn" style="width:180px;background-color:#f5f5f5;height:36px;line-height:36px;text-align:center;cursor:pointer;">上传盖章后的报名表</div>
          </Upload>
          <div class="license-img">
            <template v-if="uploadList && uploadList.length">
              <div
                class="license-img-list"
                v-for="(item, index) in uploadList"
                :key="'upload' + index"
                style="background-color:#f5f5f5;"
              >
                <template v-if="item.status === 'finished'">
                  {{item.name}}
                  <span class="line"></span>
                  <span @click="handleRemoveByArr(item)">删除</span>
                </template>
              </div>
            </template>
          </div>
        </div> -->
      <!-- </div> -->
    </div>

    <div class="application-btn">
      <Button
        type="primary"
        size="large"
        @click="finishApply"
        style="margin-right:20px;"
      >
      Submit
        <br>
      提交并完成报名</Button>
    </div>
  </div>
</template>

<script>
import config from "@assets/config.json";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "application", // 参展申请
  data() {
    return {
      list: [],
      speenInfo: null,
      orderInfo: null,
      introduction: "",
      introductionEn: "",
      defaultList: [],
      uploadList: [],
      uploadName: "",
      basicInfo: null,
      orderList: [],
      orderPrice: 0,
      orderUnint: "",
      CMOprice: 0,
      Obligatory:0
    };
  },
  components: {
  },
  computed: {
    ...mapGetters({
      formHeaders: "getFormHeaders",
      uploadUrl: "getUploadUrl",
    }),
    exhibitionId() {
      return this.$route.query.exhibitionId;
    },
    applyCompanyId() {
      return this.$route.query.applyCompanyId;
    },
    applyCompanyOrderId() {
      return this.$route.query.applyCompanyOrderId;
    },
    groupId() {
      return this.$route.query.termId;
    }
  },
  methods: {
    ...mapActions({
      getOrderDetail: "getOrderDetail",
      getApplyFlow: "getApplyFlow",
      getApplyFlowSpeed: "getApplyFlowSpeed",
      getApplyCompanyBasic: "getApplyCompanyBasic",
      finishApplyOperate: "finishApplyOperate"
    }),
    async init() {
      // 流程
      let list = await this.getApplyFlow();
      let arr=[]
      list.forEach(e=>{
        if(e.speed!==2){
          arr.push(e)
        }
      })
      this.list = arr;

      let info = await this.getApplyFlowSpeed(this.applyCompanyId);
      if (info && info.info) {
        this.speenInfo = info.info;
        if (this.list && this.list.length > 0) {
          this.list.map(c => {
            if (this.speenInfo && this.speenInfo.speed >= c.speed) {
              c.process = true;
            }
          })
        }
      }
      // this.speenInfo不存在，即此轮流程已结束
      if (!this.speenInfo) {
        if (this.applyCompanyOrderId) {
          this.$router.push("/join/pavilion/basicEn?applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId+ "&termId=" + this.groupId+"&exhibitionId="+ this.exhibitionId);
        } else {
          this.$router.push("/join/pavilion/applicationEn?exhibitionId=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId + "&termId=" + this.groupId);
        }
      }

      // 基本信息
      let basicInfo = await this.getApplyCompanyBasic(this.applyCompanyId);
      this.basicInfo = basicInfo;
      console.log("基本信息：",basicInfo);

      // 订单信息
      let orderInfo = await this.getOrderDetail(this.applyCompanyOrderId);
      if (orderInfo && orderInfo.applyFileLink) {
        this.$router.push("/join/pavilion/finishEn?exhibitionId=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId + "&termId=" + this.groupId+ "&applyCompanyOrderId=" + this.applyCompanyOrderId);
      }
      this.orderInfo = orderInfo;
      this.introduction = this.enter(orderInfo.introduction) || "";
      this.introductionEn = this.enter(orderInfo.introductionEn) || "";
      if (this.orderInfo && this.orderInfo.applyBoothOrderList.length > 0) {
        this.orderInfo.applyBoothOrderList.map(c => {
          c.orderType = "booth";
          this.orderList.push(c);
          this.orderPrice += c.totalPrice;
          this.orderUnint = c.monetaryUnit;
        })
      }
      if (this.orderInfo && this.orderInfo.applyOtherOrderList.length > 0) {
        this.orderInfo.applyOtherOrderList.map(c => {
          if(c.dePjNameGroupName!='固定费用'){
          c.orderType = "other";
          this.orderList.push(c);
          this.orderPrice += c.totalPrice;
          this.CMOprice += c.totalPrice;
          }
          else{
          
          this.orderList.push(c);
          this.orderPrice += c.totalPrice;
          this.Obligatory += c.totalPrice;

      }
        })
      }

      console.log("订单信息：",this.orderInfo);
    },
    enter(str){
      let str1=str.replace(/\n/g,"<br/>");
      return str1;
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList.push({
          name: this.uploadName,
          url: res.list[0],
          status: "finished"
        });
      } else {
        this.uploadName = "";
      }
    },
    handleFormatError(file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "Incorrect file format",
        desc: "Please upload a PDF"
      });
    },
    handleMaxSize(file) {
      this.uploadName = "";
      this.$Notice.warning({
        title: "File size exceeded the limit",
        desc: "Please upload an image within 50M"
      });
    },
    handleBeforeUpload(e) {
      this.uploadName = e.name;
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload up to${limitNum}files`
        });
      }
      return check;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    async finishApply() {
      // if (!this.uploadList || !this.uploadList[0] || !this.uploadList[0].url) {
      //   this.$Message.warning("请上传盖章后的报名表");
      //   return;
      // }
      let req = {
        Id: this.applyCompanyOrderId,
        // ApplyFileLink: this.uploadList[0].url
        ApplyFileLink: "finished"
      }
      let bool = await this.finishApplyOperate(req);
      if (bool && bool.successed) {
        this.$Message.success("Submitted Successfully！");
        this.$router.push("/join/pavilion/finishEn?exhibitionId=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId + "&termId=" + this.groupId+ "&applyCompanyOrderId=" + this.applyCompanyOrderId);
      }
    },
    downloadPdf() {
      window.open(`${config.api.reqApi}/Pdf/Index?orderId=` + this.applyCompanyOrderId, "_blank");
    },
    editBasic() {
      this.$router.push("/join/pavilion/basicEn?applyCompanyId=" + this.applyCompanyId + "&applyCompanyOrderId=" + this.applyCompanyOrderId+'&exhibitionId='+this.exhibitionId+ "&termId=" + this.groupId);
    },
    editBooth() {
      if (this.groupId) {
        this.$router.push("/join/pavilion/orderEn?exhibitionId=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId +  "&applyCompanyOrderId=" + this.applyCompanyOrderId + "&termId=" + this.groupId);
      } else {
        this.$router.push("/join/pavilion/orderEn?exhibitionId=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId +  "&applyCompanyOrderId=" + this.applyCompanyOrderId);
      }
    },
    editIntroduction() {
      if (this.groupId) {
        this.$router.push("/join/pavilion/catalogueEn?exhibitionId=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId +  "&applyCompanyOrderId=" + this.applyCompanyOrderId + "&termId=" + this.groupId);
      } else {
        this.$router.push("/join/pavilion/catalogueEn?exhibitionId=" + this.exhibitionId + "&applyCompanyId=" + this.applyCompanyId +  "&applyCompanyOrderId=" + this.applyCompanyOrderId);
      }
    }
  },
  created() {
    this.init();
  }
};
</script>

<style scoped lang='scss'>
.application {
  &-task {
    width: 100%;
    margin: 20px 0 50px;
    padding: 0 80px;
    display: flex;
    justify-content: space-between;
    color: #666;
    position: relative;
    .task-one {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 2;
      .box {
        width: 20px;
        height: 20px;
        background-color: #fff;
        box-shadow: 0px 2px 5px 0px rgba(1, 53, 97, 0.5);
        border-radius: 50%;
        margin-top: 10px;
        div {
          width: 14px;
          height: 14px;
          background-color: #8ba5bc;
          border-radius: 50%;
          margin: 3px auto 0;
        }
      }
    }
    .line {
      height: 8px;
      background-color: #d7dee4;
      position: absolute;
      width: 998px;
      left: 108px;
      top: 37px;
      z-index: 1;
    }
    .ing {
      color: #024c8b;
      .box {
        div {
          background-color: #024c8b;
        }
      }
    }
    .finished {
      color: #024c8b;
      .box {
        background-color: #024c8b;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &-header {
    width: 100%;
    height: 64px;
    background-color: #024c8b;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      line-height: 64px;
      font-size: 20px;
    }
    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }

  &-content {
    .content-title {
      width: 100%;
      height: 48px;
      background-color: #ededed;
      padding: 0 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .l {
        font-size: 18px;
        color: #333;
      }
      .r {
        color: #1890ff;
        cursor: pointer;
      }
    }
    .content-com {
      padding: 20px 60px;
      background-color: #fff;
      display: flex;
      flex-wrap: wrap;
      color: #333;
      p {
        width: calc(100% - 70px);
        margin-bottom: 5px;
      }
    }
    .content-title2 {
      width: 100%;
      height: 48px;
      background-color: #ededed;
      display: flex;
      div {
        width: 50%;
        height: 100%;
        padding: 0 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .l {
          font-size: 18px;
          color: #333;
        }
        .r {
          color: #1890ff;
          cursor: pointer;
        }
      }
    }
    .content-link {
      display: flex;
      background-color: #fff;
      div {
        width: 50%;
        padding: 20px 20px 20px 88px;
        display: flex;
        flex-wrap: wrap;
        p {
          width: calc(100% - 40px);
          margin-bottom: 5px;
        }
      }
    }
    .content-exHall {
      padding: 30px 0 30px 30px;
      background-color: #fff;
      color: #333;
      .exHall {
        display: flex;
        flex-wrap: wrap;
        &-one {
          width: 360px;
          height: 250px;
          border: 1px solid #d9d9d9;
          margin-right: 30px;
          margin-bottom: 20px;
          .top {
            padding: 20px 20px 5px 20px;
            border-bottom: 1px solid #d9d9d9;
            line-height: 1;
            height: 190px;
            p {
              margin-bottom: 15px;
              font-size: 18px;
            }
            .remark {
              font-size: 14px;
            }
          }
          .subtotal {
            font-size: 18px;
            margin-top: 20px;
            text-align: right;
            margin-right: 20px;
          }
        }
        .line {
          width: calc(100% - 30px);
          height: 1px;
          background-color: #d9d9d9;
        }
        .totalPrice {
          font-size: 18px;
          margin-top: 20px;
          width: 100%;
          padding-right: 30px;
        }
      }
    }
    .content-introduction {
      padding: 20px 30px;
      background-color: #fff;
      color: #333;
      p {
        word-break:break-all;
      }
    }
    .content-table {
      background-color: #fff;
      padding: 30px;
      .f {
        width: 180px;
        height: 36px;
        background-color: #f5f5f5;
        line-height: 36px;
        text-align: center;
        margin: 0 auto 10px;
        cursor: pointer;
      }
    }
  }

  .license-img {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    &-list {
      padding: 0 10px;
      background-color: #fff;
      display: flex;
      align-items: center;
      span {
        color: #db2a4b;
        cursor: pointer;
      }
      .line {
        width: 1px;
        height: 24px;
        background-color: #e6e6e6;
        margin: 0 6px;
      }
    }
  }
  
  &-btn {
    margin-top: 50px;
    margin-bottom: 80px;
    text-align: center;
    button {
      width: 200px;
      height: 48px;
      background-color: #024c8b;
      font-size: 16px;
      border-color: #024c8b;
    }
  }
}
</style>
